import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, sharedToken } = useAuth();
  if (!isAuthenticated && !sharedToken) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
